// SVG skeleton loaders that mirror the layout of page hero + main sections.
// Used as Suspense fallback while route chunks load.

const shimmer = "animate-pulse bg-secondary/60";

export const PageSkeleton = () => (
  <div className="pt-40" aria-hidden="true" role="status" aria-label="Loading page">
    <div className="mx-auto max-w-[1400px] px-6 pb-20 md:px-12">
      <div className={`h-3 w-32 rounded-sm ${shimmer}`} />
      <div className={`mt-6 h-14 w-3/4 rounded-sm ${shimmer}`} />
      <div className={`mt-3 h-14 w-2/3 rounded-sm ${shimmer}`} />
      <div className={`mt-8 h-4 w-1/2 rounded-sm ${shimmer}`} />
    </div>
  </div>
);

export const ServicesSkeleton = () => (
  <div aria-hidden="true" role="status" aria-label="Loading services">
    <PageSkeleton />
    <div className="mx-auto max-w-[1400px] px-6 py-16 md:px-12">
      <div className="grid gap-6 md:grid-cols-2">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="rounded-sm border border-border bg-card p-8 md:p-10">
            <div className={`h-3 w-32 rounded-sm ${shimmer}`} />
            <div className={`mt-4 h-8 w-2/3 rounded-sm ${shimmer}`} />
            <div className={`mt-3 h-3 w-1/3 rounded-sm ${shimmer}`} />
            <div className="mt-6 space-y-2">
              {Array.from({ length: 4 }).map((_, j) => (
                <div key={j} className={`h-3 w-full rounded-sm ${shimmer}`} />
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="rounded-sm border border-border bg-card p-6">
            <div className={`h-3 w-20 rounded-sm ${shimmer}`} />
            <div className={`mt-3 h-5 w-3/4 rounded-sm ${shimmer}`} />
            <div className={`mt-4 h-3 w-full rounded-sm ${shimmer}`} />
            <div className={`mt-2 h-3 w-5/6 rounded-sm ${shimmer}`} />
          </div>
        ))}
      </div>
    </div>
  </div>
);
